export const AVATAR_COLORS = [
  '#0a8081',
  '#2f6fed',
  '#7c3aed',
  '#db2777',
  '#ea580c',
  '#16a34a',
  '#0891b2',
  '#9333ea',
];

export const avatarColor = (s: string): string => {
  let h = 0;
  for (let i = 0; i < (s || '').length; i += 1)
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
};

export const initialOf = (s: string): string =>
  ((s || '').trim()[0] || '?').toUpperCase();
